// theme
import ThemeConfig from './theme';
import GlobalStyles from './theme/globalStyles';
// routes
import AdminRouter from "routes/admin/app.route";
import UserRouter from "routes/user/app.route";
// components
import ScrollToTop from './components/ScrollToTop';
import AlertMessage from "./components/alertMessage";
import { BaseOptionChartStyle } from './components/charts/BaseOptionChart';

// ----------------------------------------------------------------------

export default function App() {
  return (
    <ThemeConfig>
      <ScrollToTop />
      <GlobalStyles />
      <BaseOptionChartStyle />
      <AdminRouter />
      <UserRouter />
      <AlertMessage />
    </ThemeConfig>
  );
}
